import { createStore, applyMiddleware, compose, combineReducers } from 'redux'
import { persistState } from 'redux-devtools'
import { createLogger } from 'redux-logger'
import thunkMiddleware from 'redux-thunk'
import { reducer as formReducer } from 'redux-form'
import * as reducers from '../reducers'

const logger = createLogger({
  level: 'info',
  collapsed: true
})

const reducer = combineReducers({...reducers, form: formReducer})

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancers = composeEnhancers(
  applyMiddleware(thunkMiddleware, logger),
  persistState(window.location.href.match(/[?&]debug_session=([^&]+)\b/))
)


const store = (initialState={}) => {
  const store = createStore(
    reducer,
    initialState,
    enhancers
  )

  if (module.hot) {
    module.hot.accept('../reducers', () => {
      const nextRootReducer = require('../reducers/index').default
      store.replaceReducer(nextRootReducer)
    })
  }

  return store
}

export default store()
